import {
    graphQLRequester,
    PlayerData,
    type GraphQLDataProvider,
} from '@kinopoisk-int/player-graphql-requester';

import type { GraphqlClient } from '@/shared/lib/graphqlClient';

type StreamFormat = 'HLS' | 'DASH';
type DRMTypes = 'playready' | 'widevine' | 'clear' | 'fairplay';
type SupportedStreamFormat = Partial<Record<StreamFormat, DRMTypes[]>>;

const SUPPORTED_STREAM_FORMATS: SupportedStreamFormat[] = [
    { HLS: ['fairplay', 'clear'] },
    {
        DASH: ['playready', 'widevine', 'clear'],
    },
];

const SupportedStreamFormatHeader = {
    'x-device-supported-stream-formats': JSON.stringify(SUPPORTED_STREAM_FORMATS),
};

type OnData = (data: PlayerData) => void;

export function createFilmoscopeRequester(graphqlClient: GraphqlClient, onData?: OnData) {
    const graphQLDataProvider: GraphQLDataProvider = {
        async query(operation, variables, options) {
            const result = await graphqlClient.fetch(
                { operation, variables },
                {
                    abortSignal: options.signal,
                    headers: {
                        ...SupportedStreamFormatHeader,
                        'X-Application-VSID': options.vsid,
                    },
                }
            );

            if (!result.data) {
                throw new Error('Empty filmoscope query result');
            }

            if (result.errors) {
                const [first] = result.errors;
                if (first) {
                    throw first;
                }
            }

            return result.data;
        },
    };

    return graphQLRequester({ graphqlDataProvider: graphQLDataProvider, onData });
}
